import { render, staticRenderFns } from "./yzintegralset_add.vue?vue&type=template&id=a4a07562&scoped=true&"
import script from "./yzintegralset_add.vue?vue&type=script&lang=js&"
export * from "./yzintegralset_add.vue?vue&type=script&lang=js&"
import style0 from "./yzintegralset_add.vue?vue&type=style&index=0&id=a4a07562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a07562",
  null
  
)

export default component.exports